export { useTenants, type UseTenantsOptions } from "./hooks/useTenants";
export { useIdentity, type UseIdentityOptions } from "./hooks/useIdentity";
export { tenantsEndpoint, tenantsQuery, identityEndpoint, identityQuery } from "./queries";
export { invalidateQueriesFor } from "./invalidate-queries";
export type { DirQueryKey, DirApiConfig } from "./query";
